import {
	isAdvancedHelpCenter,
	isHelpCentersManagement,
} from '@atlassian/help-center-common-util/advanced-help-center';
import { getEnv } from '@atlassian/help-center-common-util/env';
import { isSendRawHelpCenterTypeInAnalyticsEnabled } from '@helpcenter/feature-flags';
import { getHelpCenterAri } from '@helpcenter/meta';

export const getHelpCenterAnalyticsData = () => {
	if (isHelpCentersManagement()) {
		return undefined;
	}

	const { edition } = getEnv();

	return {
		helpCenterType: isAdvancedHelpCenter() ? 'custom' : 'default',
		helpCenterAri: getHelpCenterAri(),
		...(edition ? { edition } : {}),
		...(isSendRawHelpCenterTypeInAnalyticsEnabled()
			? { helpCenterCategory: getEnv().helpCenterType }
			: {}),
	};
};
